<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string;
    desc?: string;
    /** GpxMetersDistanceField's slider is `flex-1`, so it collapses to its handle in the
     * default column. Panes that use it ask for the wider one. */
    wide?: boolean;
  }>(),
  { desc: undefined, wide: false },
);
</script>

<template>
  <div
    class="grid grid-cols-1 gap-y-[10px] border-t border-t-gpx_gray-800 py-[16px] sm:items-center sm:gap-x-[32px] sm:gap-y-0"
    :class="
      wide
        ? 'sm:grid-cols-[minmax(0,1fr)_360px]'
        : 'sm:grid-cols-[minmax(0,1fr)_260px]'
    "
  >
    <div>
      <div class="text-sm font-medium text-gpx_black-400">{{ title }}</div>
      <div v-if="desc" class="text-[13px] text-gpx_gray-300">{{ desc }}</div>
    </div>
    <div :class="wide ? 'w-full' : 'sm:justify-self-end'"><slot /></div>
  </div>
</template>
